// eslint-disable-next-line no-shadow
enum Status {
    SUBMMITED = 'SUBMMITED',
    TEMP_SUBMITTED = 'TEMP_SUBMITTED',
    STARTED = 'STARTED',
    EMPTY_INPUT = 'EMPTY_INPUT',
    NOT_EXISTING = 'NOT_EXISTING',
    INITIAL = 'INITIAL',
    NETWORK_ERROR = 'NETWORK_ERROR',
    VALID = 'VALID'
  }

export { Status as default };
